import {
  AnyAction,
  combineReducers,
  CombinedState,
  Reducer,
} from "@reduxjs/toolkit";
import {
  connectRouter,
  LocationChangeAction,
  RouterState,
} from "connected-react-router";
import { History } from "history";

import { reducer as imagesReducer } from "../components/ImageUploader/images.slice";
import { reducer as appDataReducer } from "../components/appData.slice";
import { reducer as formSettingsReducer } from "../components/formSettings.slice";
import { reducer as senderReducer } from "../features/Sender/sender.slice";
import { reducer as welcomeReducer } from "../features/Welcome/welcome.slice";

import { acFormReducer } from "./acReducer";
import { ocPropertyFormReducer } from "./ocPropertyReducer";
import { ocVehicleFormReducer } from "./ocVehicleReducer";

export const rootReducer = (
  history: History
): Reducer<
  CombinedState<{
    appData: ReturnType<typeof appDataReducer>;
    router: RouterState<unknown>;
    sender: ReturnType<typeof senderReducer>;
    formSettings: ReturnType<typeof formSettingsReducer>;
    welcome: ReturnType<typeof welcomeReducer>;
    ac: ReturnType<typeof acFormReducer>;
    ocVehicle: ReturnType<typeof ocVehicleFormReducer>;
    ocProperty: ReturnType<typeof ocPropertyFormReducer>;
    images: ReturnType<typeof imagesReducer>;
  }>,
  AnyAction | LocationChangeAction<unknown>
> =>
  combineReducers({
    appData: appDataReducer,
    router: connectRouter(history),
    sender: senderReducer,
    formSettings: formSettingsReducer,
    welcome: welcomeReducer,
    ac: acFormReducer,
    ocVehicle: ocVehicleFormReducer,
    ocProperty: ocPropertyFormReducer,
    images: imagesReducer,
  });

export type RootState = ReturnType<ReturnType<typeof rootReducer>>;
